import { ObservableArray, View } from "binder"
import { FileSelectorViewModel } from "uicomponents";
import { ReportEditorViewModel, singleReportProperty } from "./reportEditor-viewModel"

export class ReportEditorView extends View<ReportEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-CEA05549-B3A0-4CB1-B362-E99E3A2545EA"
    }
    loadHtml(): string {
        let element = require('./reportEditor.html').default;
        let style = require('./reportEditor.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set path(v: string) { this._path = v; } public get path(): string { return this._path;} private _path: string;
    public set isReportChanged(v: boolean) { this._isReportChanged = v; } public get isReportChanged(): boolean { return this._isReportChanged;} private _isReportChanged: boolean;
    public set content(v: string) { this._content = v; } public get content(): string { return this._content;} private _content: string;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    public set reportStructure(v: string) { this._reportStructure = v; } public get reportStructure(): string { return this._reportStructure;} private _reportStructure: string;
    public set properties(v: ObservableArray<singleReportProperty>) { this._properties = v; } public get properties(): ObservableArray<singleReportProperty> { return this._properties;} private _properties: ObservableArray<singleReportProperty>;
    
    addProperty(){
        this.dataContext.addProperty();
    }
    
    editReport(){
        this.dataContext.editReport();
    }
    back(){
        this.dataContext.back();
    }

    save(){
        this.dataContext.save();
    }
}
